import { GET_DOCUMENT_OUTCOME, GET_DOCUMENT_OUTCOME_FAILURE, GET_DOCUMENT_OUTCOME_SUCCESS, GET_SALES_REP_CLASSIFICATION_LIST_FAILURE, GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS } from "../Action/actionTypes";

interface InitialStateType {
  DocOutcomeData:any
  salesRepClassificationList:any
  isLoaded: boolean;
  loading: boolean;
  error: string;
}
const initialState: InitialStateType = {
 DocOutcomeData:{},
 salesRepClassificationList:{},
  isLoaded: false,
  loading: false,
  error: "",
};

const DocumentOutcomeReducer = (state = initialState, action: any) => {
  switch (action.type) {
     case GET_DOCUMENT_OUTCOME_SUCCESS:
      return {
        ...state,
        DocOutcomeData: action.payload,
        loading: false,
      };
    case GET_DOCUMENT_OUTCOME_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
      case GET_DOCUMENT_OUTCOME:
      return {
        ...state,
        loading: true,
        isLoaded: true,
      };
      case GET_SALES_REP_CLASSIFICATION_LIST_SUCCESS: return {
            ...state,
            salesRepClassificationList: action.payload
          }
      
          case GET_SALES_REP_CLASSIFICATION_LIST_FAILURE: return {
            ...state,
            salesRepClassificationList: []
          }
             default:
      return state;
    }
}
export default DocumentOutcomeReducer;